export const folderAccessSettingsKeys = {
  list: (folderId: number) => ['folder-access-settings-list', folderId],
  options: (folderId: number) => ['folder-access-settings-option', folderId],
};
